
import Model from 'flarum/Model';
import mixin from 'flarum/utils/mixin';

export default class Field extends Model {
  title = Model.attribute('title')
  btnText = Model.attribute('btnText')
  link = Model.attribute('link')
  image = Model.attribute('image')
  imageMob = Model.attribute('imageMob')

  apiEndpoint() {
    return '/banners' + (this.exists ? '/' + this.data.id : '')
  }
}
